"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
function useWindowSize() {
  const {
    0: windowSize,
    1: setWindowSize
  } = (0, _react.useState)({
    width: undefined,
    height: undefined
  });
  (0, _react.useEffect)(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}
var _default = useWindowSize;
exports.default = _default;